import { render, staticRenderFns } from "./LangWrapper.vue?vue&type=template&id=76332186"
import script from "./LangWrapper.vue?vue&type=script&lang=js"
export * from "./LangWrapper.vue?vue&type=script&lang=js"
import style0 from "./LangWrapper.vue?vue&type=style&index=0&id=76332186&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports